import type { HovGainUpgradeMpTarget } from "@/features/hoverIdle/types";
import type { MpmState } from "../mpm/mpmState";
import {
  getActiveMpmHovTargetAssignments,
  getActiveMpmHovGainUpgradeAssignments,
} from "../mpm/mpmCapacity";
import type { WallState } from "../wall/wallState";
import { resolveHovDirectMpMode } from "../wall/wallChallengePolicy";

export function getEffectiveHovTargetDirectMpAssignments(
  mpm: MpmState,
  wall: WallState,
): readonly number[] {
  if (resolveHovDirectMpMode(wall) === "mpm") {
    return getActiveMpmHovTargetAssignments(mpm);
  }
  const assignment = wall.mpWallAssignments;
  return assignment?.kind === "hov-target" ? [assignment.index] : [];
}

export function getEffectiveHovGainUpgradeDirectMpAssignments(
  mpm: MpmState,
  wall: WallState,
): readonly HovGainUpgradeMpTarget[] {
  if (resolveHovDirectMpMode(wall) === "mpm") {
    return getActiveMpmHovGainUpgradeAssignments(mpm);
  }
  const assignment = wall.mpWallAssignments;
  return assignment?.kind === "hov-gain-upgrade" ? [assignment.target] : [];
}
